import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools'
import ContactInternalSearchForm from './search-form.js'

const ContactInternalSearchModel = {
  agenciaPA: null
}

export default {
  mixins: [ActionsForm],
  name: 'ContactInternaSearch',
  data () {
    return {
      data: ContactInternalSearchModel,
      form: ContactInternalSearchForm
    }
  },
  props: {
    parentComponent: {
      type: Object
    }
  },
  methods: {
    onLoad () {
      this.onClearFilters()
    },
    onClearFilters () {
      Tools.SetFormDefaultValues(this.form)
      this.parentComponent.filters = null
      this.parentComponent.onLoadAll()
    },
    onValidateFilters () {
      let result = true
      this.data.agenciaPA = this.form.agenciaPA.value
      return result
    },
    onFilter () {
      if (this.onValidateFilters()) {
        this.$eventHub.emit('Filter', { filters: this.data })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/contacts/internal/components/search/search.js